module.exports = __webpack_public_path__ + "static/media/downWhite.93ae4842.svg";